import {Component, inject, ChangeDetectionStrategy} from "@angular/core";
import { AssetService } from "../../asset/asset.service";
import {Location} from "@angular/common";
import { map} from "rxjs/operators";

@Component({
  templateUrl: "./map-page.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MapPageComponent {
  private readonly assetService = inject(AssetService);
  private readonly location = inject(Location);

  protected readonly assets$ = this.assetService.all.pipe(
      map(assets => {
        // If an asset is selected, it's saved in the state
        // TODO: Refactor this to query param in the future
        const state = this.location.getState() as {assetId?: number};
        if(state.assetId) {
          return assets.filter(x => x.id === state.assetId);
        }


        return assets;
      }),
  );
}
